{
  "fr": {
    "filteredList": {
      "actions": {
        "showFilter": "Afficher les filtres",
        "hideFilter": "Masquer les filtres"
      }
    }
  }
}
